import { useEffect, useState } from 'react';
import { branchTermSingularCapitalised } from 'utils/terminology';
import useUserStoreLocation from '../../hooks/selectAStore/useUserStoreLocation';

const SelectAStoreResult = ({ store, setLocationError, currentStoreId }) => {
  const [storeChanged, setStoreChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [referralUrl, setReferralUrl] = useState('');

  const {
    id,
    name,
    line_1: line1,
    line_2: line2,
    line_3: line3,
    line_4: line4,
    line_5: line5,
    postcode,
    distance,
  } = store;
  const { response, setConfig } = useUserStoreLocation();

  useEffect(() => {
    if (response.result) {
      const {
        success,
        data: { fallback_location: referralUrl },
      } = response.result;
      if (success) {
        setReferralUrl(referralUrl);
        setStoreChanged(true);
        setLoading(false);
        setTimeout(() => {
          window.location.href = referralUrl;
        }, 2000);
      } else {
        setLocationError();
      }
    }
  }, [response.result]);

  const setLocation = locationId => {
    setLoading(true);
    setConfig({
      method: 'PUT',
      url: `/change-branch/${locationId}`,
    });
  };

  return (
    <div className="select-a-store-search__store-results__store">
      <div className="select-a-store-search__store-results__store-info">
        <p className="select-a-store-search__store-results__title">
          {name} <span>({distance})</span>
        </p>
        <ul className="select-a-store-search__store-results__address-list">
          {line1 !== '' && <li>{line1}</li>}
          {line2 !== '' && <li>{line2}</li>}
          {line3 !== '' && <li>{line3}</li>}
          {line4 !== '' && <li>{line4}</li>}
          {line5 !== '' && <li>{line5}</li>}
          {postcode !== '' && <li>{postcode}</li>}
        </ul>
      </div>
      <div className="select-a-store-search__store-results__store-select">
        {id === currentStoreId ? (
          <button
            disabled={true}
            className="select-a-store-search__store-results__select-store-button">
            Current {branchTermSingularCapitalised}
          </button>
        ) : (
          <button
            className={
              storeChanged
                ? 'select-a-store-search__store-results__select-store-button-changed'
                : 'select-a-store-search__store-results__select-store-button'
            }
            onClick={() => setLocation(id)}>
            {storeChanged
              ? `${branchTermSingularCapitalised} Selected`
              : `Select ${branchTermSingularCapitalised}`}
          </button>
        )}
      </div>
    </div>
  );
};

export default SelectAStoreResult;
